import Alpine from "alpinejs";
import {API} from "@/js/accounts/utils/api.js";

export default () => ({
    currentTab: 'profile',
    myAccountInit() {
        // Set initial tab
        const hash = window.location.hash?.substring(1);
        const first = document.querySelector(".c-account-details__section")?.id;
        this.currentTab = hash || first || "";
        window.addEventListener("hashchange", () => {
            this.currentTab = window.location.hash.substring(1);
        });
    },


    isActive(id) {
        console.log(`Checking if tab ${id} is active: ${this.currentTab === id}`);
        return this.currentTab === id;
    },

    setTab(id) {
        this.currentTab = id;
        history.replaceState(null, "", `#${id}`);
    },
    async logout() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        const response = await API.POST.logout(this.csrfToken)

        if (response.ok) {
            window.location.href = '/account/login/';
        } else {
            console.error('Logout failed');
        }
    }
});